// Toda tela do PowerAgents caía no mesmo `catch (e) { useAlert(GENERIC) }`, e o backend já
// mandava o motivo — código de erro, `detail`, `errors[]`. O usuário via "Something went
// wrong" para inbox ocupado, chave de config desconhecida e 500 de verdade, três coisas com
// ações diferentes.
//
// `mensagemDoErro` devolve a frase mais específica que existir, nesta ordem:
//   1. tradução do código conhecido (POWER_AGENTS.ERRORS.<CODIGO>), com interpolação
//   2. `detail` do backend (já é uma frase pronta, ex. as chaves de config recusadas)
//   3. `errors[0]` / `error` cru — pior que uma frase traduzida, melhor que o genérico
//   4. o genérico passado pela chamada
const CONHECIDOS = {
  inbox_bound_to_other_bot: 'INBOX_TAKEN',
  agent_not_provisioned: 'NOT_PROVISIONED',
  publish_in_progress: 'PUBLISH_IN_PROGRESS',
  // 502 do publish: "(runtime_unreachable)" sozinho não dizia o que fazer nem que nada mudou.
  runtime_unreachable: 'RUNTIME_UNREACHABLE',
  no_inbox: 'NO_INBOX',
  unknown_config_keys: 'UNKNOWN_CONFIG_KEYS',
  // O `detail` destes três já é uma frase, mas em pt-BR fixo e com o id cru do modelo entre
  // crases. Traduzidos aqui, o toast fala a língua da tela e cita o modelo uma vez só.
  reasoning_effort_unsupported: 'REASONING_UNSUPPORTED',
  reasoning_effort_unverifiable: 'REASONING_UNVERIFIABLE',
  reasoning_effort_invalid: 'REASONING_INVALID',
};

export function dadosDoErro(e) {
  return e?.response?.data || {};
}

export function codigoDoErro(e) {
  const d = dadosDoErro(e);
  return typeof d.error === 'string' ? d.error : null;
}

export function mensagemDoErro(e, t, generica) {
  const d = dadosDoErro(e);
  const chave = CONHECIDOS[d.error];
  if (chave) {
    return t(`POWER_AGENTS.ERRORS.${chave}`, {
      // Quem segura o inbox: o nome do agente é o que a pessoa reconhece; o do bot é o
      // fallback, e o id só aparece quando nem o bot existe mais.
      dono: d.bound_agent_name || d.bound_bot_name || d.bound_bot_id,
      chaves: Array.isArray(d.keys) ? d.keys.join(', ') : '',
      modelo: d.model,
    });
  }
  if (typeof d.detail === 'string' && d.detail.trim()) return d.detail;
  if (Array.isArray(d.errors) && d.errors.length) return String(d.errors[0]);
  if (typeof d.error === 'string' && d.error.trim()) return d.error;
  if (typeof d.message === 'string' && d.message.trim()) return d.message;
  // Sem corpo: um erro de rede ou um 500 sem JSON. A mensagem do axios diz mais que nada
  // ("Network Error", "timeout of 0ms exceeded") e não é genérica.
  if (!e?.response && e?.message) return e.message;
  return generica;
}
